import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'sr',
    description:
      'Manage subrecipients, subawards, risk assessments, terms, and monitoring activities.',
    icon: 'rp',
    name: 'Subrecipient Monitoring',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
